module.exports = __webpack_public_path__ + "static/media/usclogo.f418459e.png";